import darkTexture from "../images/dark-texture-too-small.webp";
import lightTexture from "../images/light-texture.webp";
import blackTexture from "../images/dark-gray-theme-pattern.jpg";
import lightGrayTexture from "../images/light-gray-theme-pattern.jpg";
import darkBlueTexture from "../images/dark-blue-theme-pattern.jpg";
import lightBlueTexture from "../images/light-blue-theme-pattern.jpg";
import whiteTexture from "../images/white-theme-pattern.jpg";
export const colorSettingDetection = (presetTheme: string): any => {
  if (presetTheme == "") {
    return `t2-color-setting--light`;
  } // default
  const colorSetting = presetTheme == "t2-action-theme-two" || presetTheme == "t2-theme-three" || presetTheme == "t2-theme-four" || presetTheme == "t2-theme-five" || presetTheme == "t2-theme-seven" ? `t2-color-setting--dark` : `t2-color-setting--light`;
  return colorSetting;
};
export const darkTextureWrapper = (presetTheme: string): any => {
  let componentStyles: any = null;
  if (presetTheme == "t2-theme-seven" || presetTheme == "t2-action-theme-two") {
    componentStyles = {
      backgroundImage: `url(${darkTexture.src})`
    };
  }
  return componentStyles;
};
export const themeTextureWrapper = (presetTheme: string): any => {
  let componentStyles: any = null;
  switch (presetTheme) {
    case "t2-theme-seven":
      componentStyles = {
        backgroundImage: `url(${darkTexture.src})`
      };
      break;
    case "t2-action-theme-two":
      componentStyles = {
        backgroundImage: `url(${darkTexture.src})`
      };
      break;
    case "t2-theme-six":
      componentStyles = {
        backgroundImage: `url(${whiteTexture.src})`
      };
      break;
    case "t2-theme-five":
      componentStyles = {
        backgroundImage: `url(${darkBlueTexture.src})`
      };
      break;
    case "t2-theme-four":
      componentStyles = {
        backgroundImage: `url(${lightBlueTexture.src})`
      };
      break;
    case "t2-theme-three":
      componentStyles = {
        backgroundImage: `url(${blackTexture.src})`
      };
      break;
    case "t2-theme-two":
      componentStyles = {
        backgroundImage: `url(${lightGrayTexture.src})`
      };
      break;
    default:
      componentStyles = {};
      break;
  }
  return componentStyles;
};
export const themeTextureBackgroundImage = (presetTheme: string | undefined): string | null => {
  switch (presetTheme) {
    case "t2-theme-seven":
    case "t2-action-theme-two":
      return darkTexture.src;
    case "t2-theme-six":
      return lightTexture.src;
    case "t2-theme-five":
      return darkBlueTexture.src;
    case "t2-theme-four":
      return lightBlueTexture.src;
    case "t2-theme-three":
      return blackTexture.src;
    case "t2-theme-two":
      return lightGrayTexture.src;
    case "t2-theme-one":
      return whiteTexture.src;
    default:
      return null;
  }
};
export interface Property {
  name: string;
  value: boolean;
}
export interface Prefixes {
  [key: string]: string;
}
const prefixes: Prefixes = {
  eyebrow: "t2-eye",
  header: "t2-header",
  subheader: "t2-subheader",
  description: "t2-description"
};
export const getClassNames = (baseClass: string, properties: Property[]): string => {
  const primaryContentClassesArray = [baseClass, ...properties.map(prop => prefixes[prop.name] ? `${prefixes[prop.name]}__${prop.value ? "exists" : "noexists"}` : "")];
  return primaryContentClassesArray.join(" ");
};
export const renderHeaderConditionally = (headerClasses: string, headerText: string, headerElement: string): any => {
  if (!headerText) return null;
  headerText = headerText.replace("™", "<span class='inline-block align-super text-3xl max-sm:text-lg min-sm:max-lg:text-lg'>™</span>");
  // \n entered in Contentful Symbol fields is stored as the literal two-character
  // sequence backslash-n. Honour it as a soft break: visible on md+ screens,
  // hidden on small viewports so mobile layouts stay intact.
  headerText = headerText.replace(/\\n/g, '<br class="break-hint" />');
  switch (headerElement) {
    case "h1":
      return <h1 className={headerClasses} dangerouslySetInnerHTML={{
        __html: headerText as string
      }}></h1>;
    case "h2":
    default:
      return <h2 className={headerClasses} dangerouslySetInnerHTML={{
        __html: headerText as string
      }}></h2>;
  }
};
export const truncateText = (text: string, length: number) => {
  return text.length > length ? text.slice(0, length) + "..." : text;
};